import React from 'react'
import "./Sidetitle.css"

function Sidetitle(props) {
  return (
  <h1 className='sidetitle'>{props.title}</h1>
  )
}

export default Sidetitle
